/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsEditor extends _Ext.GridEditorBase<ReceiptDetailsRow> {
        protected getColumnsKey() { return "Finance.PaymentDetails"; }
        protected getDialogType() { return ReceiptDetailsDialog; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as PaymentDialog).calculateTotals();
                }
            })
        }
        protected getButtons() {
            var buttons = super.getButtons();
            return buttons;
        }

        
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}